// http://developer.piwik.org/guides/tracking-javascript-guide

import screenSize from './screen_size';
import config from '../config';
import $ from 'jquery';

class AnalyticsService {
    constructor() {
        this.piwikEnabled = config.get('featureFlags.piwikEnabled');
        this.config = config;
        this.screenSize = screenSize;
        this.env = config.get('env');
    }

    trackContentImpressions() {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(['trackVisibleContentImpressions', true, 750]);
            }
        }
        return this;
    }

    trackEvent(eventList) {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(eventList);
            }
        }
        return this;
    }

    trackClick(name, value) {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                const size = this.screenSize.getSize();
                this.trackEvent(['trackEvent', 'click_' + size, name, value]);
            }
        }
        return this;
    }

    trackInView(name, value) {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                const size = this.screenSize.getSize();
                this.trackEvent(['trackEvent', 'in_view_' + size, name, value]);
            }
        }
        return this;
    }


    trackAdLoadFail(name, value) {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                const size = this.screenSize.getSize();
                this.trackEvent(['trackEvent', 'ad_load_fail' + size, name, value]);
            }
        }
        return this;
    }

    trackPageView() {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(['trackPageView']);
            }
        }
        return this;
    }

    setUserId(id) {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(['setUserId', id]);
            }
        }
        return this;
    }

    enableHeartBeatTimer() {
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(['enableHeartBeatTimer']);
            }
        }
        return this;
    }

    // TODO: add to search
    trackSearch(keyword, results) {
        window.fbq('track', 'Search');
        if (this.piwikEnabled === true) {
            if (this.env !== 'development') {
                window._paq.push(['trackSiteSearch',
                    // Search keyword searched for
                    keyword,
                    // Search category selected in your search engine. If you do not need this, set to false
                    this.screenSize.getSize(),
                    // Number of results on the Search results page. Zero indicates a 'No Result Search Keyword'. Set to false if you don't know
                    results
                ]);
            }
        }
        return this;
    }

    onSlideshowRefresh() {
        // Invoke the following trackers doing slideshow slide event
        this.trackComscore();
        this.trackNielsen();
        this.trackFacebookAds();
    }

    trackChartbeat() {
        var loading = 0;

        function performChartbeatTracking() {
            // The actual action of setting up variables to pass to analytics
            const model = window.bootstrap_obj;
            const series = model.series;
            const author = model.author.display_name;
            const siteName = model.site.name;
            let cbAuthors = '';
            let cbSections = '';
            let cbSponsoredName = '';

            if (window._sf_async_config) {
                // Author name
                if (author) {
                    cbAuthors = author;
                }

                // Section
                if (series && series.supertag) {
                    cbSections = series.supertag.plain;
                } else {
                    cbSections = siteName;
                }

                // Series
                if (series && series.sponsored && series.sponsored === true) {
                    if (series.advertiser && series.advertiser !== '') {
                        cbSponsoredName = series.advertiser + ' | ' + series.title;
                    }
                }

                window._sf_async_config.authors = cbAuthors;
                window._sf_async_config.sections = cbSections;
                window._sf_async_config.sponsorName = cbSponsoredName;
            }
            window.pSUPERFLY.virtualPage(window.location.pathname);
            // console.log('track chartbeat', window._sf_async_config);
        }

        // If the script or object doesn't exist, we need to load it in
        if (typeof window.pSUPERFLY === 'undefined' && loading === 0) {
            loading = 1;
            const chartbeatScript = (document.location.protocol === 'https:') ? 'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/js/chartbeat.js' : 'http://static.chartbeat.com/js/chartbeat_pub.js';
            $.getScript(chartbeatScript, (data, textStatus) => {
                if (textStatus === 'success') {
                    performChartbeatTracking();
                }
            });
        } else {
            performChartbeatTracking();
        }
    }

    trackComscore() {
        var loading = 0;

        function performComscoreTracking() {
            const model = window.bootstrap_obj;
            const site = model.site.slug.toUpperCase();

            // reset COMSCORE
            window.COMSCORE.beacon({
                c1: 2,
                c2: 6916907,
                options: {
                    url_append: 'comscorekw=' + site
                }
            });
            // console.log('perform comscore tracking', site);
        }

        if (typeof window.COMSCORE === 'undefined' && loading === 0) {
            loading = 1;
            $.getScript('//b.scorecardresearch.com/beacon.js', (data, textStatus) => {
                if (textStatus === 'success') {
                    performComscoreTracking();
                }
            });
            // console.log('Comscore Error:');
        } else {
            performComscoreTracking();
        }
    }

    trackNielsen() {
        var loading = 0;

        if (typeof window.Nielsen_Event !== 'function' && loading === 0) {
            loading = 1;
            /* eslint-disable */
            // No where to get that script
            (function Nielsen_Event() {
                let d = new Image(1, 1);
                d.onerror = d.onload = function () {
                    d.onerror = d.onload = null;
                };
                d.src = ['//secure-us.imrworldwide.com/cgi-bin/m?ci=us-805310h&cg=0&cc=1&si=', escape(window.location.href),
                    '&rp=', escape(document.referrer),
                    '&ts=compact&c0=usergen,1&rnd=', (new Date()).getTime()].join('');
                // console.log('nielsen dynamic load');
            })();
        } else {
            window.Nielsen_Event();
            /* eslint-enable */
            // console.log('using neilsen from win');
        }
    }

    trackFacebookAds() {
        var loading = 0;

        function performFBAdsTracking() {
            const model = window.bootstrap_obj;
            const series = model.series;
            const kind = model.kind;
            const type = model.type;

            window._fbq.push(['addPixelId', '6025492976361']);
            window._fbq.push(['track', 'User', {
                type: type,
                kind: kind,
                supertag: (series && series.title) ? series.title : '',
                sponsored: (series && series.sponsored === true) ? 'true' : 'false'
            }]);

            // Conversion Event
            window._fbq.push(['track', 'ViewPage', {
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                language: navigator.language
            }]);
            // console.log('perform fb ad tracking');
        }

        if (typeof window._fbq === 'undefined' && loading === 0) {
            loading = 1;
            $.getScript('//connect.facebook.net/en_US/fbds.js', (data, textStatus) => {
                if (textStatus === 'success') {
                    performFBAdsTracking();
                }
            });
        } else {
            performFBAdsTracking();
        }
    }
}

const analyticsService = new AnalyticsService();

// Global function after piwik is loaded in
/*
 window.piwikAsyncInit = function () {
 console.log('piwik loaded');
 };
 */

export default analyticsService;
